module.exports = __webpack_public_path__ + "static/media/025.759e77cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/025.jpg
// module id = 498
// module chunks = 0